import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation('home');

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20fashion%20photography%20featuring%20neatly%20arranged%20cream%20linen%20shirt%2C%20tan%20leather%20wallet%2C%20silver%20watch%2C%20round%20sunglasses%20and%20white%20cotton%20tote%20bag%20on%20warm%20oatmeal%20textured%20surface%2C%20soft%20morning%20sunlight%20casting%20long%20gentle%20shadows%2C%20minimal%20scandinavian%20editorial%20style%2C%20harmonious%20earth%20tone%20palette%20with%20pops%20of%20olive%20green&width=1800&height=1200&seq=hero-kakobuy-v2-2026&orientation=landscape"
          alt="Kakobuy Spreadsheet - moda i akcesoria"
          title="Kakobuy Spreadsheet produkty"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            {/* Left Text */}
            <div className="flex-1 text-center lg:text-left pt-20 md:pt-24 pb-8 lg:pb-24">
              <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
                {t('hero_title_1')}
                <br />
                <span className="text-primary-300">{t('hero_title_2')}</span>
              </h1>
              <p className="text-background-50/80 text-base md:text-lg max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed font-body">
                {t('hero_subtitle')}
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-300 font-label font-semibold text-sm whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2 group"
                >
                  {t('hero_title_1')}
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
                </a>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full hover:bg-background-50/25 transition-all duration-300 font-label font-semibold text-sm whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2 group"
                >
                  {t('btn_buy_now')}
                  <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
                </a>
              </div>
            </div>

            {/* Right Visual - decorative floating card */}
            <div className="hidden lg:flex flex-1 items-center justify-center">
              <div className="relative w-full max-w-md aspect-[4/5] rounded-2xl overflow-hidden bg-background-50/10 backdrop-blur-sm border border-background-50/20">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20vertical%20product%20flat%20lay%20with%20folded%20oatmeal%20cashmere%20sweater%20and%20dark%20brown%20leather%20belt%20coiled%20beside%20minimal%20silver%20jewelry%20on%20warm%20cream%20linen%20backdrop%2C%20soft%20afternoon%20light%20from%20side%20window%2C%20magazine%20editorial%20composition%2C%20refined%20neutral%20palette%20with%20subtle%20terracotta%20accent&width=800&height=1000&seq=hero-card-v2-side&orientation=portrait"
                  alt="Kakobuy Spreadsheet produkt"
                  title="Kakobuy Spreadsheet - produkty"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}